import React, { useEffect, useState }  from 'react'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { ROUTE, SUB_DIRECTORY } from 'constants/general'
import Styles from './styles.module.sass'

export function NextCardButton(props){
    const {
        setUdCard
    } = props

    const route = ROUTE
    const associatedCards = decodeStorage('associatedCards')
    const cardending = decodeStorage('cardending')
    const seccionPortal = window.location.pathname.replace(`/${SUB_DIRECTORY}`, '') || '/'

    const handleNextTarjetas = () => {
        let poicitionCard = associatedCards.findIndex(cosa => cosa.card_ending === cardending)

        if(poicitionCard < (associatedCards.length -1)){
            encodeStorage('cardending', associatedCards[poicitionCard +1].card_ending)
            encodeStorage('sears_numero_internet', associatedCards[poicitionCard +1].no_internet)
            setUdCard(true)
        }else{
            encodeStorage('cardending', associatedCards[0].card_ending)
            encodeStorage('sears_numero_internet', associatedCards[0].no_internet)
            setUdCard(true)
        }
    };

    const [ valid, setValid ] = useState(false)
    useEffect(()=>{
        if(route?.find(item => item === seccionPortal )){  
            setValid(true)
        }
    },[])

    return(
        associatedCards &&
            associatedCards?.length >= 2 &&
                valid &&
                    <div className={Styles?.arrowCards} onClick={handleNextTarjetas}></div>    
    )
}